export default {
  LIST: 'VOD.ITEMS.LIST',
  SEARCH: 'VOD.ITEMS.SEARCH',
  CREATE: 'VOD.ITEMS.CREATE',
  UPDATE: 'VOD.ITEMS.UPDATE',
  REMOVE: 'VOD.ITEMS.REMOVE',
};



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/events/types/items.js